<!-- Created by henian.xu on 2020/4/27. -->

<template>
    <el-form
        v-if="formData"
        class="dynamic-form"
        label-position="top"
        size="small"
        ref="form"
        :model="formModel"
        :rules="formRules"
        v-bind="formDataUiProps"
    >
        <template v-for="field in fieldsList">
            <el-form-item
                v-if="field.isAvailable"
                :key="field.id"
                v-show="isShow(field)"
                :label="`${field.label}:`"
                :prop="field.name"
                v-bind="field.uiProps"
                :extra="field.tips"
            >
                <template
                    v-if="field.properties&&field.properties.tips"
                ><div class="tips">{{field.properties.tips}}</div></template>
                <!--                <div>{{formModel[field.name]}}</div>
                <div>{{field.componentName}}</div>-->
                <Component
                    :is="field.componentName"
                    ref="fields"
                    v-bind="field.componentProps"
                    v-model="formModel[field.name]"
                    is-full-value
                    @success="onUploadSuccess($event,field)"
                    @error="onUploadError($event,field)"
                ></Component>
            </el-form-item>
        </template>
    </el-form>
</template>

<script>
import { Utils } from 'vmf';
import { buildValidate, buildProps, buildValue, getComponentName } from './dynamicStore';

const { debounce, getUniqueId, isString, isObject, hasOwn } = Utils;

export const isNumber = val => typeof val === 'number';
/**
 * 判断两个对象是否相等
 * @param obj1
 * @param obj2
 * @returns {boolean}
 */
export function isObjEqual(obj1, obj2) {
    if (obj1 === obj2) return true;
    const keys1 = Object.getOwnPropertyNames(obj1);
    const keys2 = Object.getOwnPropertyNames(obj2);
    if (keys1.length !== keys2.length) return false;
    // eslint-disable-next-line no-restricted-syntax
    for (const key of keys1) {
        if (obj1[key] !== obj2[key]) return false;
    }
    return true;
}
/* const testFormDataJson = {
    name: 'tzzyczzsq',
    fields: [
        {
            name: 'studyHistory',
            label: '学习履历',
            type: 'studyHistory',
            properties: {
                readonly: false,
                defaultValue: '',
                placeholder: '请输入',
                options: '[DICTIONARY]:specialOperationReviewType',
                value: '',
                tips: '',
                degreeDictionary: 'education',
                required: true,
            },
        },
        {
            name: 'dictionary',
            label: '字典',
            type: 'dictionary',
            properties: {
                readonly: false,
                defaultValue: '',
                placeholder: '请输入',
                options: '[DICTIONARY]:specialOperationReviewType',
                value: '',
                tips: '',
                required: true,
            },
        },
        {
            name: 'dictionary-bitwise',
            label: '字典',
            type: 'dictionary',
            properties: {
                readonly: false,
                defaultValue: '',
                placeholder: '请输入',
                options: '[DICTIONARY]:specialOperationReviewType',
                value: '',
                tips: '',
                bitwise: true,
                required: true,
            },
        },
        {
            name: 'signature',
            label: '签名',
            type: 'signature',
            properties: {
                readonly: false,
                defaultValue: '',
                placeholder: '添加经历',
                value: '',
                tips: '',
                required: true,
            },
        },
        {
            name: 'fullName',
            label: '姓名',
            type: 'text',
            properties: {
                readonly: false,
                defaultValue: '',
                placeholder: '请输入',
                value: '',
                tips: '',
                required: true,
            },
        },
        {
            name: 'sex',
            label: '性别',
            type: 'select',
            properties: {
                readonly: false,
                extraOptions: [
                    {
                        name: '请选择',
                        id: '',
                    },
                ],
                defaultValue: '',
                options: [
                    {
                        name: '男',
                        id: '1',
                    },
                    {
                        name: '女',
                        id: '2',
                    },
                ],
                placeholder: '请选择',
                value: '',
                tips: '',
                required: true,
            },
        },
        {
            name: 'regionId',
            label: '地区',
            type: 'region',
            properties: {
                readonly: false,
                defaultValue: '',
                placeholder: '请选择',
                value: '',
                tips: '家庭住址',
                required: true,
            },
        },
        {
            name: 'address',
            label: '详细地址',
            type: 'textarea',
            properties: {
                minRows: 1,
                readonly: false,
                defaultValue: '',
                placeholder: '请输入',
                value: '',
                tips: '家庭住址',
                required: true,
            },
        },
        {
            name: 'companyName',
            label: '工作单位',
            type: 'text',
            properties: {
                readonly: false,
                defaultValue: '',
                placeholder: '请输入',
                value: '',
                tips: '',
                required: true,
            },
        },
        {
            name: 'politicalAffiliation',
            label: '政治面貌',
            type: 'select',
            properties: {
                readonly: false,
                extraOptions: [
                    {
                        name: '请选择',
                        id: '',
                    },
                ],
                defaultValue: '',
                options: '[DICTIONARY]:politicalAffiliation',
                enableOther: 999999,
                placeholder: '请选择',
                value: '',
                tips: '',
                required: true,
            },
        },
        {
            name: 'tel',
            label: '联系电话',
            type: 'text',
            properties: {
                readonly: false,
                defaultValue: '',
                validates: [
                    {
                        method: '',
                        type: 'mobile',
                        message: '手机号格式不正确',
                    },
                ],
                placeholder: '请输入',
                value: '',
                tips: '',
                required: true,
            },
        },
        {
            name: 'healthStatus',
            label: '健康状态',
            type: 'select',
            properties: {
                readonly: false,
                extraOptions: [
                    {
                        name: '请选择',
                        id: '',
                    },
                ],
                defaultValue: '',
                options: '[DICTIONARY]:healthStatus',
                enableOther: 999999,
                placeholder: '请选择',
                value: '',
                tips: '',
                required: true,
            },
        },
        {
            name: 'idCardTypeName',
            label: '证件类型',
            type: 'text',
            properties: {
                readonly: false,
                defaultValue: '',
                placeholder: '请输入',
                value: '',
                tips: '',
                required: true,
            },
        },
        {
            name: 'idCardNo',
            label: '证件号码',
            type: 'text',
            properties: {
                readonly: false,
                defaultValue: '',
                placeholder: '请输入',
                value: '',
                tips: '',
                required: true,
            },
        },
        {
            name: 'highestEducation',
            label: '最高学历',
            type: 'select',
            properties: {
                readonly: false,
                extraOptions: [
                    {
                        name: '请选择',
                        id: '',
                    },
                ],
                defaultValue: '',
                options: '[DICTIONARY]:highestEducation',
                enableOther: 999999,
                placeholder: '请选择',
                value: '',
                tips: '',
                required: true,
            },
        },
        {
            name: 'specialOperationReviewType',
            label: '复审类型',
            type: 'select',
            properties: {
                readonly: false,
                extraOptions: [
                    {
                        name: '请选择',
                        id: '',
                    },
                ],
                defaultValue: '',
                options: '[DICTIONARY]:specialOperationReviewType',
                placeholder: '请选择',
                value: '',
                tips: '',
                required: true,
            },
        },
        {
            name: 'photoTwoInch',
            label: '2寸照片',
            type: 'file',
            properties: {
                readonly: false,
                defaultValue: '',
                action: '/comm/rs/attachment/uploadFileLibrary',
                placeholder: '',
                value: [],
                tips: '2寸白底免冠',
                required: true,
                maxFiles: 1,
                uiProps: {
                    fit: 'contain',
                    columns: 2.5,
                    itemHeight: '120%',
                    cropper: {
                        aspectRatio: 0.83333,
                    },
                },
                accept: 'image/!*',
            },
            uiProps: {
                direction: 'column',
            },
        },
        {
            name: 'certExamType',
            label: '证考类型',
            type: 'hidden',
            properties: {
                readonly: false,
                defaultValue: '',
                placeholder: '请输入',
                value: '',
                tips: '',
                required: false,
            },
        },
    ],
    uiProps: {
        border: true,
        align: 'right',
        showFeedback: true,
    },
    attrs: {
        rules: [
            {
                action: 'show',
                conditions: [
                    {
                        field: 'certExamType',
                        value: '2',
                        operator: 'eq',
                    },
                ],
                targetFields: ['specialOperationReviewType'],
                relation: 'all',
            },
        ],
        initializedIsReadOnly: false,
    },
}; */

export default {
    name: 'DynamicForm',
    data() {
        return {
            formModel: {},
            formRules: {},
            buildForm_: null,
            buildControlRules_: null,
            fieldsList: [], // 只是为了记 vue 可观察
        };
    },
    props: {
        data: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        initData() {
            const { data } = this;
            if (!data) return null;
            const { initDataJson } = data;
            if (!initDataJson) return null;
            try {
                if (isString(initDataJson)) return JSON.parse(initDataJson);
                if (isObject(initDataJson)) return initDataJson;
                return null;
            } catch (e) {
                return null;
            }
        },
        formData() {
            const { data } = this;
            if (!data) return null;
            const { formDataJson } = data;
            if (!formDataJson) return null;
            try {
                if (isString(formDataJson)) return JSON.parse(formDataJson);
                if (isObject(formDataJson)) return formDataJson;
                return null;
                // return testFormDataJson;
            } catch (e) {
                return null;
            }
        },
        formAttrs() {
            // TODO
            return (this.formData || {}).attrs || {};
        },
        formControlRules() {
            const { formAttrs } = this;
            return formAttrs.rules || [];
        },
        fields() {
            const res = (this.formData || {}).fields || [];
            // 构建 formItem props
            return res.reduce((pre, cur) => {
                const { type } = cur;
                cur.componentName = getComponentName(cur);
                cur.id = getUniqueId('form-item-');
                cur.componentProps = buildProps(cur);
                cur.isAvailable = true;
                if (!/signature/.test(type)) pre.push(cur);
                return pre;
            }, []);
        },
        fieldsNameMap() {
            return this.fields.reduce((pre, cur) => {
                pre[cur.name] = cur;
                return pre;
            }, {});
        },
        fieldsKeyMap() {
            return this.fields.reduce((pre, cur) => {
                if (cur.key) pre[cur.key] = cur;
                return pre;
            }, {});
        },
        fieldsKeyNameMap() {
            return this.fields.reduce((pre, cur) => {
                const { name, key } = cur;
                if (key) pre[key] = name;
                return pre;
            }, {});
        },
        //
        formDataUiProps() {
            const res = { ...this.formData.uiProps };
            delete res.align;
            return res;
        },
    },
    watch: {
        /* formData: {
            handler(val) {
                if (!val) console.error('formJson error');
            },
            immediate: true,
        }, */
        fields: {
            handler() {
                if (!this.buildForm_) {
                    this.buildForm_ = debounce(this.buildForm);
                }
                this.buildForm_();
            },
            immediate: true,
        },
        // 处理表单控制规则
        formModel: {
            handler() {
                if (!this.buildControlRules_) {
                    this.buildControlRules_ = debounce(this.buildControlRules);
                }
                this.buildControlRules_();
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        buildForm() {
            const { fields, initData } = this;
            if (!fields || !fields.length) return;
            const model = {};
            const rules = {};
            fields.forEach(item => {
                const { name } = item;
                model[name] = buildValue(item, initData);
                // 构建校验
                const rules_ = buildValidate(item);
                if (rules_ && rules_.length) {
                    const rule = rules[name] || (rules[name] = []);
                    rule.push(...rules_);
                }
                this.fieldsList.push(item);
            });

            this.formModel = model;
            this.formRules = rules;
            this.$refs.form.resetFields();
        },
        buildControlRules() {
            const { formModel, formRules, fieldsNameMap, fieldsKeyMap, formControlRules, fieldsKeyNameMap } = this;
            formControlRules.forEach(rule => {
                const { conditions, relation, action, targetFields } = rule;
                const isAny = relation === 'all' || relation === 'or';
                const isConfirm = conditions.reduce((pre, condition) => {
                    const { operator, value } = condition;
                    const fieldName = fieldsKeyNameMap[condition.field] || condition.field;
                    const { properties } = fieldsNameMap[fieldName] || {};
                    const { optionsProps } = properties || {};
                    let model = formModel[fieldName];
                    let val = value;
                    if (isObject(model)) {
                        const props = {
                            id: 'id',
                            ...(optionsProps || {}),
                        };
                        model = model[props.id];
                        val = value[props.id];
                    }
                    if (/^eq|not$/.test(operator)) {
                        let isEq = `${model}` === `${val}`;
                        if (isObject(model)) isEq = isObjEqual(model, val);
                        if (operator === 'not') isEq = !isEq;
                        return isAny ? pre || isEq : pre && isEq;
                    }
                    // 条件中是否包含value中的值
                    if (/^in|notIn$/.test(operator)) {
                        if (isNumber(val)) val = [val];
                        let isContains = val.indexOf(model) !== -1;
                        if (operator === 'notIn') isContains = !isContains;
                        return isAny ? pre || isContains : pre && isContains;
                    }
                    // value 中是否包含条件中的值
                    if (/^contains|notContains$/.test(operator)) {
                        if (isNumber(model)) model = [model];
                        let isContains = model.indexOf(val) !== -1;
                        if (operator === 'notContains') isContains = !isContains;
                        return isAny ? pre || isContains : pre && isContains;
                    }
                    return pre;
                }, !isAny);

                switch (action) {
                    case 'show': {
                        targetFields.forEach(fieldName => {
                            const field = fieldsKeyMap[fieldName] || fieldsNameMap[fieldName];
                            if (field) {
                                field.isAvailable = isConfirm;
                                if (field.isAvailable) {
                                    // 重新构建验证规则
                                    const rules_ = buildValidate(field);
                                    formRules[field.name] = rules_ && rules_.length ? [...rules_] : null;
                                }
                            }
                        });
                        break;
                    }
                    case 'hide': {
                        targetFields.forEach(fieldName => {
                            const field = fieldsKeyMap[fieldName] || fieldsNameMap[fieldName];
                            if (field) field.isAvailable = !isConfirm;
                            if (field.isAvailable) {
                                // 重新构建验证规则
                                const rules_ = buildValidate(field);
                                formRules[field.name] = rules_ && rules_.length ? [...rules_] : null;
                            }
                        });
                        break;
                    }
                    case 'readonly': {
                        targetFields.forEach(fieldName => {
                            const field = fieldsKeyMap[fieldName] || fieldsNameMap[fieldName];
                            if (field) field.uiProps.disabled = isConfirm;
                        });
                        break;
                    }
                    default:
                        break;
                }
            });
        },
        async submit() {
            const { form, fields } = this.$refs;
            const validateList = [form];
            fields.reduce((pre, cur) => {
                if (cur.validate) {
                    pre.push(cur);
                }
                return pre;
            }, validateList);
            const field = await this.$utils.validateForm(validateList, true);
            console.log(field);
            await this.$refs.form.validate();
            const { formModel, fieldsList } = this;
            let res = {};
            try {
                res = JSON.parse(JSON.stringify(formModel));
            } catch (e) {
                return Promise.reject(e);
            }
            // 重组表单数据
            return fieldsList.reduce((pre, cur) => {
                const { name, isAvailable, componentName } = cur;
                if (!isAvailable) {
                    // pre[name] = '';
                    return pre;
                }
                let val = res[name];
                if (componentName === 'Upload') {
                    val = val.map(item => item.address).join(',');
                }
                pre[name] = val;
                return pre;
            }, {});
        },
        isShow(field) {
            const { type } = field;
            return !/hidden|signature/.test(type);
        },
        onUploadSuccess(val, field) {
            console.log(val, field);
            const { componentName } = field;
            if (componentName !== 'Upload') return;
            const { formModel } = this;
            const { initData } = val.data || {};
            if (!initData) return;
            Object.entries(initData).forEach(([key, value]) => {
                if (!hasOwn(formModel, key)) return;
                console.log(key, value);
                formModel[key] = value;
            });
            // console.log(formModel);
        },
        onUploadError(/* val, field */) {
            // const { componentName } = field;
            // if (componentName !== 'Upload') return;
            // this.$messageBox.alert(val.message || val);
        },
    },
};
</script>

<style lang="scss">
.dynamic-form {
    > .el-form-item {
        > .el-form-item__label,
        > .el-form-item__content {
            line-height: 1.2;
            padding-bottom: 0;
            > .tips {
                font-size: $little * 100%;
                color: $gray6;
                padding-bottom: $padding-small;
            }
        }
    }
}
</style>
